import Paper from '@mui/material/Paper';
import { alpha, styled } from '@mui/material/styles';
import { DataGridPro } from '@mui/x-data-grid-pro';

export const TableContainer = styled(Paper)(({ theme }) => ({
  width: '100%',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[2],
  overflow: 'hidden',
}));

export const DataGridWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'gridHeight' && prop !== 'verticalOffset' && prop !== 'verticalOffsetMobile',
})<{
  gridHeight: number;
  verticalOffset?: number;
  verticalOffsetMobile?: number;
}>(({ gridHeight, verticalOffset = 240, verticalOffsetMobile = 300 }) => ({
  height: `min(${gridHeight}px, calc(100vh - ${verticalOffset}px))`,
  maxHeight: `calc(100vh - ${verticalOffset}px)`,
  overflow: 'hidden',
  ['@media (max-width: 899.95px)']: {
    height: `min(${gridHeight}px, calc(100vh - ${verticalOffsetMobile}px))`,
    maxHeight: `calc(100vh - ${verticalOffsetMobile}px)`,
  },
}));

export const StyledDataGrid = styled(
  DataGridPro,
  {},
)(({ theme }) => ({
  height: '100%',
  border: 'none',
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
    {
      outline: 'none',
      boxShadow: 'none',
    },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: theme.palette.table.headerBackground,
    borderBottom: 'solid',
    borderWidth: theme.spacing(0.125),
    borderColor: theme.palette.table.divider,
  },
  '& .MuiDataGrid-filler.MuiDataGrid-filler--horizontal': {
    backgroundColor: theme.palette.table.headerBackground,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: theme.typography.fontWeightMedium,
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: 'transparent',
  },
  '& .MuiDataGrid-columnHeaderFiller': {
    backgroundColor: theme.palette.table.headerBackground,
  },
  '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
    padding: theme.spacing(0, 1),
  },
  "& .MuiDataGrid-columnHeader[aria-colindex='1'], & .MuiDataGrid-cell[aria-colindex='1']": {
    paddingLeft: theme.spacing(3),
  },
  '& .MuiDataGrid-iconButtonContainer .MuiIconButton-root': {
    backgroundColor: 'transparent',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: alpha(theme.palette.info.main, 0.04),
  },
  '&.row-clickable .MuiDataGrid-row:hover': {
    cursor: 'pointer',
  },
  '&:not(.row-clickable) .MuiDataGrid-row:hover': {
    cursor: 'default',
  },
  '& .MuiDataGrid-footerContainer': {
    borderTop: `${theme.spacing(0.125)} solid ${theme.palette.table.divider}`,
    paddingRight: theme.spacing(1),
  },
})) as typeof DataGridPro;
